<script>
  import { onMount, afterUpdate } from 'svelte'
  import { fade } from 'svelte/transition'
  import BaseDonut from '../core/dataviz/BaseDonut.svelte'
  import IntersectionObserver from '../util/IntersectionObserver.svelte'
  // import JsonDebug from '../../../utilities/JsonDebug.svelte'

  export let suffix = ''
  export let value

  export let store = undefined
  $: storeValue = store ? $store : undefined

  export let loadingStore = undefined

  let dialStartAngle = 90
  let dialEndAngle = 89.999
  let valueActual = 0

  let once = true

  const addObjectValues = (obj)=>{
    // add things up
    // console.log('adding obj values')
    let tmpArray = Object.values(value)
    return tmpArray.forEach(x => valueActual = valueActual + Number(x))
  }

  const calculateValueActual = ()=>{
    if(storeValue && typeof storeValue !== 'object') {
      // console.log('Decorative: calculateValueActual fired, storeValue is not an obj')
      valueActual = Number(storeValue)
    } else if(storeValue && typeof storeValue === 'object') {
      // console.log('Decorative: calculateValueActual fired, storeValue is an obj')
      valueActual = addObjectValues(storeValue)
    } else if(typeof value === 'object') {
      // console.log('Decorative: calculateValueActual fired, no storeValue, and value is an obj')
      valueActual = addObjectValues(value)
    } else {
      // console.log('Decorative: calculateValueActual fired, but no conditions matched. Assigning 0.')
      valueActual = 0
    }
  }

  afterUpdate(calculateValueActual)
 
  // $: debugObj = {
  //   storeValue: storeValue,
  //   value: value,
  //   valueActual: valueActual,
  // }
</script>

<IntersectionObserver class="" let:intersecting once bottom={ 500 }>
  { #if intersecting && storeValue > 0 || valueActual > 0 }
    <div class="p-4" in:fade={{ delay:150 }}>
      <BaseDonut value={ storeValue || valueActual } min={ 0 } max={ storeValue || valueActual } dialStartAngle={ dialStartAngle } dialEndAngle={   dialEndAngle } suffix={ suffix } />
      { #if $loadingStore }loading data...{ /if }
    </div>
  { :else }
    <div style="min-height: 400px;"></div>  
  { /if }
</IntersectionObserver>